import { render, staticRenderFns } from "./SelectBaseAmountDialog.vue?vue&type=template&id=28aa2540&scoped=true"
import script from "./SelectBaseAmountDialog.vue?vue&type=script&lang=js"
export * from "./SelectBaseAmountDialog.vue?vue&type=script&lang=js"
import style0 from "./SelectBaseAmountDialog.vue?vue&type=style&index=0&id=28aa2540&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28aa2540",
  null
  
)

export default component.exports